import { render, staticRenderFns } from "./SalReceivableModal.vue?vue&type=template&id=1e513453&scoped=true&"
import script from "./SalReceivableModal.vue?vue&type=script&lang=js&"
export * from "./SalReceivableModal.vue?vue&type=script&lang=js&"
import style0 from "./SalReceivableModal.vue?vue&type=style&index=0&id=1e513453&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e513453",
  null
  
)

export default component.exports